import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Homepage from './pages/homepage';
import ServicesOverview from './pages/services-overview';
import AboutPartnership from './pages/about-partnership';
import LitigationSupport from './pages/litigation-support';
import BusinessValuation from './pages/business-valuation';
import CaseStudies from './pages/case-studies';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/terms-of-service';
import BookConsultation from './pages/book-consultation';
import BookingConfirmation from './pages/booking-confirmation';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/services" element={<ServicesOverview />} />
          <Route path="/about" element={<AboutPartnership />} />
          <Route path="/litigation-support" element={<LitigationSupport />} />
          <Route path="/valuation" element={<BusinessValuation />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/book-consultation" element={<BookConsultation />} />
          <Route path="/booking-confirmation" element={<BookingConfirmation />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;